import { styled } from "@mui/material";
import { TextField } from "@mui/material";
import DatePicker from "react-datepicker";

export const TitleContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: "6px",
  width: "100%",
});

export const TitleHeader = styled("h2")(({ theme }) => ({
  fontSize: "20px",
  fontWeight: 500,
  lineHeight: "27px",
  textAlign: "left",
  color: theme.palette.text.primary,
}));

export const TitleSubheader = styled("h3")(({ theme }) => ({
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "20px",
  textAlign: "left",
  color: theme.palette.text.primary,
}));

export const PatientTitleContainer = styled(TitleContainer)({});

export const ContactContainer = styled(TitleContainer)({});

interface InputLabelProps {
  disabled?: boolean;
}

export const InputLabel = styled("label", {
  shouldForwardProp: (prop) => prop !== "disabled",
})<InputLabelProps>(({ theme, disabled }) => ({
  fontSize: "16px",
  fontWeight: 500,
  lineHeight: "23px",
  paddingBottom: "4px",
  color: disabled ? theme.palette.text.disabled : theme.palette.text.primary,
}));

export const ObscuredSingleInput = styled(TextField)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  fontSize: "16px",
  fontWeight: 400,
  "& input": {
    height: "32px",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "18px",
    textAlign: "left",
    padding: "12px",
    fontFamily: "Poppins",
  },
}));
ObscuredSingleInput.defaultProps = {
  inputProps: {
    "data-openreplay-obscured": "",
  },
};

export const InputExample = styled("span")(({ theme }) => ({
  fontSize: "12px",
  fontWeight: 400,
  lineHeight: "15px",
  color: theme.palette.text.secondary,
  paddingTop: "4px",
}));

export const ErrorMessage = styled("span")(({ theme }) => ({
  color: theme.palette.error.main,
  fontSize: "12px",
}));

export const SelectedFilesContainer = styled("label")({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  marginTop: "16px",
  alignItems: "center",
  justifyContent: "center",
});

export const SelectedFile = styled("div")({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  background: "#f9f9f9",
  width: "100%",
  padding: "8px 0px",
});

export const SelectedFileTitle = styled("p")(({ theme }) => ({
  fontSize: "14px",
  paddingLeft: "8px",
  fontWeight: 400,
  lineHeight: "24px",
  color: theme.palette.text.primary,
}));

export const SelectedFileSummary = styled(SelectedFile)({
  justifyContent: "flex-start",
});

export const SkeletonContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: "20px",
  width: "100%",
  marginTop: "18px",
});

export const Datepicker = styled(DatePicker)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "40px",
  width: "100%",
  boxSizing: "border-box",
  border: `1px solid ${theme.palette.text.secondary}`,
  borderRadius: "4px",
}));

